/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var cache,
    $img = document.getElementById('canvas'),
    runner = {};


runner.show = function ( config ) {
    var uri = config.uri || '';


    // uri = 'file://' + uri;
    uri = encodeURI(uri);
    cache = new Image();
    cache.onload = function () {
        if ( config.onload ) {
            config.onload();
        }
        $img.style.background = 'url(' + uri + ') no-repeat center';
    };
    cache.onerror = config.onerror;
    cache.src = uri;

};

module.exports = runner;
